import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { push } from "react-router-redux";
import { getToken, clearToken } from "../../helpers/utility";
import actions from "./actions";
import authApi from "../../api/authApi";

const onLoginRequest = async (credentials) =>
  await authApi.Login({ param: credentials, success: (res) => res.data });
/*
  await axios.request({
    method: 'post',
    url: authApi.Login(),
    data: credentials
  })
    .then(res => res.data);
*/
export function* loginRequest() {
  yield takeEvery(actions.LOGIN_REQUEST, function* ({ payload }) {
    try {
      yield put({ type: actions.LOGIN_PENDING });

      const result = yield call(onLoginRequest, payload);

      if (result) {
        yield put({
          type: actions.LOGIN_SUCCESS,
          token: result.token,
          profile: result.profile,
        });
      } else {
        yield put({
          type: actions.LOGIN_ERROR,
          error: "UNKOWN ERROR",
        });
      }
    } catch (error) {
      let errorData = "error in connection";

      if (error.message) errorData = error.message;
      else if (
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.message
      ) {
        errorData = error.response.data.error.message;
      }

      yield put({
        type: actions.LOGIN_ERROR,
        error: errorData,
      });
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield localStorage.setItem("id_token", payload.token);
    yield put({ type: actions.SET_ROLE });
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () { });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    clearToken();
    yield put(push("/"));
  });
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
    const token = getToken().get("idToken");

    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        profile: "Profile",
      });
    }
  });
}
export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
  ]);
}
